module.exports = __webpack_public_path__ + "images/FUSA_icons/073-placeholder.4d4bca18603ffe091c0506b88c083868.svg";